<div data-at-installation-list id="installation-list flex flex-col">
  <div data-at-head class="head flex flex-col">
    <div
      data-at-headline
      class="headline flex flex-row justify-start items-center lt-md:items-start lt-md:flex-auto"
    >
      <div
        class="flex-[260px] min-w-[260px] max-w-[260px] lt-md:flex-[100%] lt-md:min-w-[100%] lt-md:max-w-[100%]"
      >
        <div data-at-search class="search">
          <ng-content select="[search]"></ng-content>
        </div>
      </div>
    </div>
    <ng-content select="[limited]"></ng-content>
    <div
      data-at-sorter
      class="sorter lt-lg:!hidden flex flex-row justify-start items-end flex-[60px] max-h-[60px] min-h-[60px]"
    >
      <ng-content select="[sort]"></ng-content>
    </div>
  </div>
  <div data-at-body class="body flex flex-col flex-auto">
    <ng-content select="[installation-item]"></ng-content>
    <ng-content select="[no-results]"></ng-content>
  </div>
  <div data-at-foot class="foot flex flex-col flex-auto">
    <ng-content select="[paginator]"></ng-content>
  </div>
</div>
